import { ExcelPalletsItem, SendPalletsExcelRow } from '../types';

export const sendPalletsExcelRowToExcelPalletsItemMapper: (
   sendPalletsExcelRowData: SendPalletsExcelRow,
) => ExcelPalletsItem = sendPalletsExcelRowData => ({
   palletType: sendPalletsExcelRowData.palletType,
   palletsAmount: sendPalletsExcelRowData.palletsAmount,
});
